import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PaymentSuccessDetailsResponse {
  applicationId?: string;
  applicationDateTime?: string;
  gstRegNo?: string;
  internalTransactionRef?: string;
  paymentMethod?: string;
  paymentTimeStamp?: string;
  totalFee?: string;
  transactionNumber?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetCoordinatorAppealPaymentSuccessDetails = ({
  uuid,
  onSuccess,
  onError,
}: Input) => {
  const getCoordinatorAppealPaymentSuccessDetails = async () => {
    const res = await axiosClient.get<PaymentSuccessDetailsResponse>(
      GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_QUERY_KEY,
    getCoordinatorAppealPaymentSuccessDetails,
    {
      onSuccess,
      onError,
    }
  );
};
